import { RouteMetadata } from './types';

export const modelsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/models',
        section: 'models',
        view: 'list',
        descriptionTemplate: 'User is viewing the models list',
        capabilities: [
            'View all available LLM models',
            'Filter models by provider',
            'View model pricing and specifications',
            'See model usage statistics',
            'Compare different models',
        ],
        hints: [
            'Models are LLMs from providers like OpenAI, Anthropic, Google, etc.',
            'Each model has different capabilities, pricing, and context limits',
            'Models can be used in workflow nodes for text generation',
            'The list shows model names, providers, and pricing information',
        ],
    },
];
